import { render } from "./TableDelinquents.vue?vue&type=template&id=901bb8ce&scoped=true"
import script from "./TableDelinquents.vue?vue&type=script&lang=js"
export * from "./TableDelinquents.vue?vue&type=script&lang=js"

import "./TableDelinquents.vue?vue&type=style&index=0&id=901bb8ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-901bb8ce"]])

export default __exports__